import React, { useState } from 'react';
import {
  FormGroup,
  Grid,
  openNotificationWithIcon,
  Page,
  PageContent,
  useUserinfo,
} from '@mss/mss-component-library';
import { useTranslation } from 'react-i18next';
import Breadcrumbs from '../common/Breadcrumbs';
import TimeAgo from 'react-timeago';
import { notification, Select } from 'antd';
import Fetch from 'jsx/common/util/_fetch';

type PutBody = {
  language: string;
};

type Language = 'en' | 'ja';

const languages: { [key: string]: string } = {
  en: 'English',
  ja: '日本語',
};

const languages_en_ja = {
  en: '英語',
  ja: 'Japanese',
};

export const ApiUpdateLanguage = async (body: PutBody) => {
  return Fetch.patch(`/api/me/`, {
    body: JSON.stringify(body),
  });
};

function Profile() {
  const [t, i18n] = useTranslation('profile');
  const [, fetchMe, user] = useUserinfo();

  const [languageUpdating, setLanguageUpdating] = useState(false);

  async function updateLanguage(language: Language) {
    setLanguageUpdating(true);
    const resp = await ApiUpdateLanguage({ language });

    if (resp.status >= 200 && resp.status < 300) {
      openNotificationWithIcon(
        notification.success,
        t('LanguageUpdateSuccessNotificationHeader'),
        t(`Language successfully updated to (LANGUAGE)`, {
          language: languages_en_ja[language],
        })
      );
      fetchMe();

      i18n.changeLanguage(language);
    } else {
      openNotificationWithIcon(
        notification.error,
        t('LanguageUpdateFailNotificationHeader'),
        t('LanguageUpdateFailNotificationMsg', {
          language: languages[language],
        })
      );
    }
    setLanguageUpdating(false);
  }

  return (
    <Page
      breadCrumbs={<Breadcrumbs />}
      main={
        <PageContent title={t('Profile')}>
          <Grid.Row>
            <Grid.Col width={4}>
              <FormGroup
                label={t('First name')}
                input={<>{user?.first_name}</>}
              />
            </Grid.Col>
            <Grid.Col width={4}>
              <FormGroup
                label={t('Last name')}
                input={<>{user?.last_name}</>}
              />
            </Grid.Col>
            <Grid.Col width={4}>
              <FormGroup
                label={t('E-mail address')}
                input={<>{user?.email}</>}
              />
            </Grid.Col>
            <Grid.Col width={4}>
              <FormGroup label={t('User ID')} input={<>{user?.id}</>} />
            </Grid.Col>
            <Grid.Col width={4}>
              <FormGroup
                label={t('Last login')}
                input={
                  user?.last_login ? (
                    <TimeAgo date={user?.last_login} />
                  ) : (
                    <>{'Never'}</>
                  )
                }
              />
            </Grid.Col>
            <Grid.Col width={4}>
              <FormGroup
                label={t('Language')}
                input={
                  <Select
                    style={{ width: '100%', marginRight: 16 }}
                    defaultValue={(user?.language || 'en') as Language}
                    onChange={updateLanguage}
                    loading={languageUpdating}
                    disabled={languageUpdating}
                  >
                    {Object.keys(languages).map((x: string) => (
                      <Select.Option key={x} value={x}>
                        {languages[x]}
                      </Select.Option>
                    ))}
                  </Select>
                }
              />
            </Grid.Col>
          </Grid.Row>
        </PageContent>
      }
    />
  );
}

export default Profile;
